import { ActionType, createReducer } from 'typesafe-actions';
import { PaymentTrip } from 'store/types/payments';
import * as actions from 'store/actions/rebooking';
import { TicketCreditInformationOld } from 'store/types';

const initialState: TicketCreditInformationOld = {
  bookingId: '',
  data: [],
  success: false,
  totalCredit: 0,
  totalPenality: 0,
  tripOld: {} as PaymentTrip,
  ticketOld: [],
};

export const RebookingReducer = createReducer<TicketCreditInformationOld, ActionType<typeof actions>>(initialState)
  .handleAction(actions.getCreditBookingInformation.success, (state, { payload }) => ({
    ...state,
    ...payload,
  }))
  .handleAction(actions.setTripOld, (state, { payload }) => ({
    ...state,
    tripOld: payload.tripOld,
  }))
  .handleAction(actions.setTicketCreditOld, (state, { payload }) => ({
    ...state,
    ticketOld: payload.ticket,
  }));
